import { render, staticRenderFns } from "./CustomerReviewDashboard.vue?vue&type=template&id=34514f6c&scoped=true&"
import script from "./CustomerReviewDashboard.vue?vue&type=script&lang=ts&"
export * from "./CustomerReviewDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerReviewDashboard.vue?vue&type=style&index=0&id=34514f6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34514f6c",
  null
  
)

export default component.exports